module.exports = __webpack_public_path__ + "img/schedule-service-bar.4eb20ce3.png";